/**
 * Pago de Growthly Corporation Systems.
 *
 * El cobro se realiza mediante el enlace de pago oficial alojado por PayPal.
 * Growthly no procesa ni almacena datos de pago: el cliente completa la
 * operación íntegramente en el entorno de PayPal.
 *
 * No hay API, credenciales, webhooks ni creación de órdenes desde la web.
 */
export const PAYPAL_PAYMENT_URL =
  'https://www.paypal.com/ncp/payment/JHCJA5DUGZXAC'
export function formatPrice(amount: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount)
}
